import { Button, CircularProgress } from "@mui/material";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import {
  createStaffCustomerIncentive,
  getStaffIncentive,
} from "../../utils/api";
import CustomModal, { ModalInput } from "../Modal";

const StaffIncentive = ({ staffId }) => {
  const [loading, setLoading] = useState(false);
  const [openModal, setOpenModal] = useState(false);

  const [newIncentive, setNewIncentive] = useState({
    staffId: staffId,
    incentive: "",
  });

  const fetchIncentives = async () => {
    setLoading(true);
    const [success, data] = await getStaffIncentive(staffId);
    if (success) {
      setNewIncentive({
        incentive: data?.customerIncentive,
        staffId: staffId,
      });
    } else {
      toast.error("Failed to fetch incentives");
    }
    setLoading(false);
  };

  const handleCreateIncentive = async () => {
    if (!newIncentive.incentive) {
      toast.error("Please enter incentive amount");
      return;
    }

    setLoading(true);
    const [success, data] = await createStaffCustomerIncentive(newIncentive);
    if (success) {
      toast.success("Incentive updated successfully");
      fetchIncentives();
      setOpenModal(false);
    } else {
      toast.error("Failed to update incentive");
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchIncentives();
  }, [staffId]);

  return (
    <div className="flex flex-col  border border-black  ">
      <h2 className="text-xl font-semibold bg-secondary border-b border-black p-3">
        Customer Incentives
      </h2>

      <div className="flex items-center justify-between p-4 ">
        <div>
          <div className="text-sm text-gray-600">Incentive Amount</div>
          <div className="text-xl font-semibold">
            {newIncentive.incentive ? `₹${newIncentive.incentive}` : "Not set"}
          </div>
        </div>
        <Button
          variant="contained"
          color="primary"
          onClick={() => setOpenModal(true)}
          disabled={loading}
        >
          {loading ? <CircularProgress size={20} /> : "Edit"}
        </Button>
      </div>

      <CustomModal
        open={openModal}
        setOpen={setOpenModal}
        title="Update Customer Incentive"
        width="md:w-[30rem]"
        onClick={handleCreateIncentive}
        loading={loading}
      >
        <div className="flex flex-col gap-4">
          <div className="flex flex-col gap-2">
            <div className="bg-secondary border-2 border-black px-2 py-1">
              Incentive Amount
            </div>
            <ModalInput
              width={"w-full"}
              type="number"
              value={newIncentive.incentive}
              onChange={(e) => {
                setNewIncentive({
                  ...newIncentive,
                  incentive: e.target.value,
                });
              }}
            />
          </div>
        </div>
      </CustomModal>
    </div>
  );
};

export default StaffIncentive;
